<template>
  <my-bottom-sheet v-model="show">
    <div style="padding: 15px">
      <template v-if="type=='notice'">
        <div style="display: flex;flex-direction: column;padding: 10px;">
          <div :style="'padding:0px;font-size:1.3em;font-weight:bold;margin-bottom:15px'">
            {{ preview_title }}
          </div>

          <div style="width: 100%;overflow-y: auto;max-height: 60vh;">
            <div
                :class="'fr-element fr-view'" style="width:100%;margin:auto;">
              <div v-html="preview_contents">
              </div>
            </div>
          </div>

          <div class="add_items"
               :style="';margin-top:15px;display: flex;width: 100%;padding:0;font-size:'+(default_font_size*1.1)+'em;font-weight:bold;'">
            <div style="flex: 1;padding:0">
              <div class="rounded_card w100_h100 cancel"
                   style="padding: 15px;margin: 10px;cursor: pointer"
                   @click.stop="close(1)"
              >
                {{ $t('confirm') }}
              </div>
            </div>
          </div>
        </div>
      </template>
      <template v-else-if="type=='ops_info'">
        <store-info v-show="store != null" :store="store" />

        <div class="add_items"
             :style="'margin-top:15px;display: flex;width: 100%;padding: 10px 0;font-size:'+(default_font_size*1.1)+'em;font-weight:bold;'">
          <div style="flex: 1;padding: 20px 20px 0 20px">
            <div class="rounded_card w100_h100 cancel"
                 style="padding: 15px;margin: 10px;cursor: pointer;"
                 @click.stop="close(1)"
            >
              {{ $t('confirm') }}
            </div>
          </div>
        </div>
      </template>

      <template v-else-if="type=='qr'">

        <div class="container">
          <h1>
            {{ $t('smartphone_qr_order') }}
          </h1>

          <p>

            {{ $t('qr_code_instructions') }}

          </p>

        </div>



        <div style="display: flex;width: 100%;justify-content: center">
          <qr-code :size="170" :text="getSmartorderUrl()" style="justify-content: center;margin-top: 15px"/>
        </div>

        <div class="add_items"
             :style="'margin-top:15px;display: flex;width: 100%;padding: 10px 0;font-size:'+(default_font_size*1.1)+'em;font-weight:bold;'">
          <div style="flex: 1;padding: 20px 20px 0 20px">
            <div class="rounded_card w100_h100 cancel"
                 style="padding: 15px;margin: 10px;cursor: pointer;"
                 @click.stop="close(1)"
            >
              {{ $t('confirm') }}
            </div>
          </div>
        </div>
      </template>
      <template v-else-if="type=='review_guide'">
        <review-event />
      </template>
      <template v-else-if="type=='apply_sale'">
        <div style="padding: 10px;font-size: 1.2em">

          <div style="padding: 20px">
            <my-input-text
                v-model="sale_code"
                mtype="text"
                ref="addr_input"
                @enter="apply_code"
                autofocus
                :label="$t('enter_discount_code')"/>
          </div>


          <div style="flex: 1;padding: 5px 20px 0 20px;display: flex">

            <div class="rounded_card w100_h100 cancel"
                 style="padding: 15px;margin: 10px;cursor: pointer;"
                 @click.stop="close()"
            >
              {{ $t('cancel') }}
            </div>


            <div class="rounded_card w100_h100 btn_next"
                 style="flex:2;padding: 15px;margin: 10px;cursor: pointer;"
                 @click.stop="apply_code()"
            >
              {{ $t('apply_code') }}
            </div>

          </div>
        </div>
      </template>

      <template v-else-if="type=='qr_guide'">

          <point-event @close="close"/>

      </template>

      <template v-else-if="type=='download_app'">
        <div :style="'padding: 20px 15px 15px 20px;font-size:1.3em;font-weight:bold;'">
          {{ $t('download_checkout_app') }}
        </div>

        <div style="text-align: center;padding: 15px;">
          <img src="/images/app_download.png" style="width: 90%">
        </div>

        <div class="add_items"
             :style="'margin-top:0px;display: flex;width: 100%;padding: 10px 0;font-size:'+(default_font_size*1.1)+'em;font-weight:bold;'">
          <div style="flex: 1;padding: 5px 20px 0 20px;display: flex">

            <div class="rounded_card w100_h100 cancel"
                 style="padding: 15px;margin: 10px;cursor: pointer;"
                 @click.stop="close()"
            >
              {{ $t('confirm') }}
            </div>

          </div>
        </div>
      </template>
      <template
          v-else
      >
        <div style="display: flex; flex-direction: column; align-items: center; justify-content: center; padding: 22px;">
          <div :style="'padding: 20px 15px 15px 20px;font-size:1.3em;font-weight:bold;'"
               v-html="title"
          >
          </div>
          <div style="width: 80%;margin-top: 10px" class="msform" v-if="input">
            <input type="text" v-model="input_txt">
          </div>
          <div class="add_items"
               :style="'margin-top:15px;display: flex;width: 100%;padding: 10px 0 0 10px;font-size:'+(default_font_size*1.1)+'em;font-weight:bold;'">
            <div style="flex: 1">
              <div class="rounded_card w100_h100 cancel"
                   style="padding: 15px;margin: 10px;cursor: pointer"
                   @click.stop="close(1)"
              >
                {{ $t('cancel') }}
              </div>
            </div>
            <div style="flex: 1">
              <div class="rounded_card w100_h100 btn_next"
                   @click.stop="ok1(1)"
                   style="padding: 15px;margin: 10px;cursor: pointer"
              >
                {{ $t('confirm') }}
              </div>
            </div>
          </div>
        </div>
      </template>
    </div>
  </my-bottom-sheet>
</template>
<script>
import {mapGetters} from "vuex";
import VueQRCodeComponent from 'vue-qrcode-component';
import store from "@/store";
import MyInputText from "@/components/common/MyInputText.vue";
import ReviewEvent from "@/components/page/ReviewEvent.vue";
import PointEvent from "@/components/page/PointEvent.vue";
import StoreInfo from "@/components/form/StoreInfo.vue";
import MyBottomSheet from "@/components/common/MyBottomSheet.vue";

export default {
  components: {
    MyBottomSheet,
    PointEvent,
    MyInputText,
    'qr-code': VueQRCodeComponent,
    ReviewEvent,
    StoreInfo
  },
  name: "confirm_popup",
  computed: mapGetters({
    tablet_auth:'tablet_auth',
    offline_info: 'offline_info',
    shop_info: 'shop_info',
    torder_no: 'torder_no',
    shop_uid: 'shop_uid',
    default_font_size: 'default_font_size',
  }),
  mounted() {
    this.emitter.on('confirm_popup', this.open);
    this.emitter.on('confirm_popup_close', this.close);
  },
  data: () => ({
    open_status_arr:['mon','tue','wed','thu','fri','sat','sun'],
    exists_open_status:false,
    open_status:null,
    sale_code: '',
    preview_title: '',
    preview_contents: '',
    preview_ver: 1,
    type: '',
    title: '',
    show: false,
    input: false,
    input_txt: '',
    callback: null,
    store: null,
  }),
  methods: {
    time2:function(time) {
      let [hour, minute] = time.split(":").map(Number);
      let label = "";
      let nextDay = false;

      if (hour >= 24) {
        hour -= 24;
        nextDay = true;
      }

      if (hour === 0) {
        label = this.$t('morning')+" 12";
      } else if (hour < 6) {
        label = this.$t('morning') + ` ${hour}`;
      } else if (hour < 12) {
        label = this.$t('morning') + ` ${hour}`;
      } else if (hour === 12) {
        label = this.$t('noon') + ` 12`;
      } else {
        label = this.$t('noon') + ` ${hour - 12}`;
      }

      return `${nextDay ? this.$t('nextday') + " " : ""}${label}:${minute.toString().padStart(2, "0")}`;
    },
    submit_review() {

    },
    getSmartorderUrl() {
      let SMARTORDER_URL = store.state.my_env('smartorder');
      var url = "https://gw." + SMARTORDER_URL + "/api/main/start_order?shopid=" + this.shop_uid + "&tid=" + this.torder_no;
      return url;
    },
    parse_ops_info() {
      /*let v = this.offline_info.shop_open_status_converted
      this.open_status = JSON.parse(v)
      console.log(this.open_status)
      if(v)
        this.exists_open_status = true
      else
        this.exists_open_status = false*/
      this.store = {
        name: this.shop_info.name,
        tel: this.offline_info.tel,
        address: this.shop_info.address,
        ceo: this.shop_info.ceo,
        idnum: this.shop_info.idnum,
        corpname: this.shop_info.corpname,
        hours: JSON.parse(this.offline_info.shop_open_status_converted)
      }
    },
    open(o) {
      this.show = true;

      this.callback = o.callback;
      this.input = !!o.input;
      this.title = o.title;

      if (o.qr) {
        this.type = "qr";
      } else if (o.ops_info) {
        this.type = "ops_info";
        // parse
        this.parse_ops_info()
      } else if (o.qr_guide) {
        this.type = "qr_guide";
      } else if (o.review_guide) {
        this.type = "review_guide";
      } else if (o.apply_sale) {
        this.type = "apply_sale";
      } else if (o.download_app) {
        this.type = "download_app";
      } else if (o.notice) {
        this.type = "notice";

        // load contents
        this.load_contents(o.value);
      } else {
        this.type = "";
      }
    },
    getNoticeDetail(id, callback) {
      var url = "/api/myshp/get/notice/detail?shopid=" + this.shop_info.shopid + "&id=" + id;
      this.$http.get(url)
          .then(data => {
            var v = data.data;
            callback(v);
          });
    },
    load_contents(value) {
      var v = this;
      this.getNoticeDetail(value, function (data) {
        v.preview_title = data.title;
        v.preview_contents = data.contents;
        v.preview_ver = data.ver;
      });
    },
    go_guide() {
      this.emitter.emit("confirm_popup", {
        qr_guide: true,
      });
    },
    apply_code() {
      // 코드 적용
      //this.sale_code

      var data = JSON.parse(this.offline_info.sale_ref)
      data.code = this.sale_code
      data.uid = this.shop_uid
      var url = "/core-api/main/check/offline/sale_code/v2";

      this.$http.post(
          url, data
      ).then(res => {

        let cached_code = res.data
        this.$store.commit('sale_code', { value: cached_code });

        // 카트를 비운다
        try {
          localStorage.removeItem('cart_v2')
          localStorage.removeItem('cart_v2_hash')
          localStorage.removeItem('cart_v2_exp')

          this.$store.commit('cart_items', {value: []})

        } catch (e) {
        }

        this.$toast.info(this.$t('applied_successfully'), {
          position: "top",
        });

        this.apply_sale_order();
      }).catch(err => {
        this.$toast.error(this.$t('invalid_code'), {
          position: "top",
        });
      });

      this.show = false;
    },
    apply_sale_order() {
      //APPLY_SALE
      var data = this.offline_info.apply_sale;
      //console.log(data);
      this.$store.commit('member_sale', { value: data });
    },
    go_apps() {
      // Check if the userAgent string contains 'Android'
      const isAndroid = /Android/.test(navigator.userAgent);

      // Check if the userAgent string contains 'iPhone'
      const isiPhone = /iPhone/.test(navigator.userAgent);


      if(this.tablet_auth) {
        // open
        this.emitter.emit("confirm_popup", {
          download_app: true,
        });
        return
      }

      // Example usage
      if (isAndroid) {
        window.open('https://play.google.com/store/apps/details?id=com.mocoplex.myshop.checkout&hl=en_US&pli=1');
      } else if (isiPhone) {
        window.open('https://apps.apple.com/kr/app/%EB%A7%88%EC%9D%B4%EC%83%B5-%EC%B2%B4%ED%81%AC%EC%95%84%EC%9B%83/id1590822341');
      } else {
        // open
        this.emitter.emit("confirm_popup", {
          download_app: true,
        });
        //download_app
      }
    },
    close() {
      this.show = false;
    },
    ok1() {
      try {
        //console.log(this.callback)
        this.callback(this.input_txt);
      } catch (e) {
        console.log(e);
      }
      this.show = false;
    },
  },
};
</script>
<style scoped>
.clk_event:active {
  background-color: var(--qro-primary-color);
  color: white;
}


/*inputs*/
.msform input, .msform textarea {
  padding: 15px;
  border: 1px solid #ccc;
  border-radius: 0px;
  margin-bottom: 10px;
  width: 100%;
  box-sizing: border-box;
  font-family: montserrat;
  color: #2C3E50;
  font-size: 13px;
}

.msform input:focus, .msform textarea:focus {
  -moz-box-shadow: none !important;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
  border: 1px solid #ee0979;
  outline-width: 0;
  transition: All 0.5s ease-in;
  -webkit-transition: All 0.5s ease-in;
  -moz-transition: All 0.5s ease-in;
  -o-transition: All 0.5s ease-in;
}


 .container {
   max-width: 1200px;
   margin: 0 auto;
 }

/* Header Section */
.header {
  text-align: center;
  margin-bottom: 40px;
}

.header h1 {
  font-size: 42px;
  color: #2c3e50;
  margin-bottom: 15px;
  font-weight: 700;
}

.header p {
  font-size: 18px;
  color: #7f8c8d;
  max-width: 600px;
  margin: 0 auto;
}

/* Phone Cards Section */
.cards-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: 30px;
  margin-bottom: 60px;
}

.card {
  background: white;
  border-radius: 20px;
  padding: 30px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.card:hover {
  transform: translateY(-5px);
  box-shadow: 0 15px 40px rgba(0, 0, 0, 0.15);
}

.card-header {
  display: flex;
  align-items: center;
  margin-bottom: 25px;
}

.platform-icon {
  width: 50px;
  height: 50px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 24px;
  color: white;
  margin-right: 15px;
}

.instagram-bg {
  background: linear-gradient(45deg, #f09433 0%, #e6683c 25%, #dc2743 50%, #cc2366 75%, #bc1888 100%);
}

.naver-bg {
  background: #03C75A;
}

.google-bg {
  background: #4285F4;
}

.card-title {
  flex: 1;
}

.card-title h3 {
  font-size: 20px;
  color: #2c3e50;
  margin-bottom: 5px;
}

.rating {
  display: flex;
  align-items: center;
  gap: 5px;
  color: #f39c12;
  font-size: 14px;
}

.phone-preview {
  width: 100%;
  height: 400px;
  background: #f8f9fa;
  border-radius: 15px;
  margin-bottom: 20px;
  padding: 20px;
  border: 2px solid #e9ecef;
}

.preview-item {
  background: white;
  border-radius: 10px;
  padding: 15px;
  margin-bottom: 15px;
  border: 1px solid #e9ecef;
}

.preview-image {
  width: 100%;
  height: 100px;
  background: linear-gradient(135deg, #e9ecef 0%, #f8f9fa 100%);
  border-radius: 8px;
  margin-bottom: 10px;
}

.preview-text {
  font-size: 14px;
  color: #6c757d;
  line-height: 1.5;
}

.card-features {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.feature {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px;
  background: #f8f9fa;
  border-radius: 10px;
  font-size: 14px;
  color: #495057;
}

.feature-icon {
  width: 20px;
  height: 20px;
  background: #6c757d;
  border-radius: 50%;
}

/* CTA Section */
.cta-section {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 20px;
  padding: 50px;
  text-align: center;
  color: white;
  box-shadow: 0 15px 35px rgba(102, 126, 234, 0.3);
}

.cta-title {
  font-size: 32px;
  margin-bottom: 20px;
  font-weight: 700;
}

.cta-subtitle {
  line-height: 1.3;
  font-size: 16px;
  margin-bottom: 40px;
  opacity: 0.9;
}

.cta-buttons {
  display: flex;
  gap: 20px;
  justify-content: center;
  flex-wrap: wrap;
}

.btn {
  padding: 15px 35px;
  border-radius: 10px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  border: none;
  text-decoration: none;
  display: inline-block;
}

.btn-primary {
  background: white;
  color: #667eea;
}

.btn-primary:hover {
  background: #f8f9fa;
  transform: translateY(-2px);
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
}

.btn-secondary {
  background: rgba(255, 255, 255, 0.2);
  color: white;
  border: 2px solid white;
}

.btn-secondary:hover {
  background: rgba(255, 255, 255, 0.3);
  transform: translateY(-2px);
}

/* Responsive Design */
@media (max-width: 768px) {
  .header h1 {
    font-size: 32px;
  }

  .platforms-row {
    gap: 30px;
  }

  .platform-logo {
    width: 60px;
    height: 60px;
    font-size: 28px;
  }

  .cta-section {
    padding: 30px 20px;
  }

  .cta-title {
    font-size: 24px;
  }

  .cta-buttons {
    flex-direction: column;
  }

  .btn {
    width: 100%;
  }
}

/* Subtle animations */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.card {
  animation: fadeIn 0.6s ease-out;
}

.card:nth-child(1) { animation-delay: 0.1s; }
.card:nth-child(2) { animation-delay: 0.2s; }
.card:nth-child(3) { animation-delay: 0.3s; }
</style>